import { render } from "./pluginPropView.vue?vue&type=template&id=0f6ef2e0&ts=true"
import script from "./pluginPropView.vue?vue&type=script&lang=ts"
export * from "./pluginPropView.vue?vue&type=script&lang=ts"

import "./pluginPropView.vue?vue&type=style&index=0&id=0f6ef2e0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__